var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('div',{staticClass:"home-page-inner"},[_c('div',{staticClass:"home-page-content"},[_c('h2',[_vm._v("WELCOME")]),_c('p',[_vm._v("欢迎进入工程设备招采系统")]),_c('span',[_vm._v("请点击左侧导航，选择你想查看的内容")])])])])
}]

export { render, staticRenderFns }